import { Component } from 'react';
import { changeSettings } from './query';
import { isTrue } from '../../helpers/isTrue';
import { withTranslation } from 'react-i18next';
import { changeOptIn } from '../OptIn/query';

class AuthorSettings extends Component {
    constructor(props) {
        super();
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onChangeInputOptIn = this.onChangeInputOptIn.bind(this);
        this.state = {
            report_permission_all_authors: isTrue(props.report_permission_all_authors) ?? false,
            report_permission_individual_authors:
                isTrue(props.report_permission_individual_authors) ?? false,
            show_competitive_analysis: isTrue(props.show_competitive_analysis) ?? false,
        };
    }

    onChangeInput(e) {
        try {
            const data = {
                [e.target.name]: e.target.checked,
            };
            this.setState({
                ...data,
            });
            changeSettings(data, this.props.csrf_token);
        } catch (err) {
            console.log(err);
        }
    }

    onChangeInputOptIn(e) {
        try {
            const data = {
                [e.target.name]: e.target.checked,
            };
            this.setState({
                ...data,
            });
            changeOptIn(data);
        } catch (err) {
            console.log(err);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div
                className={`${
                    !this.props.fromOnboard ? 'card' : ''
                } rounded-main table-main settings-authors-container`}
            >
                {!this.props.fromOnboard && (
                    <div className="card-header" style={{ borderRadius: '10px' }}>
                        <div className="box-header">{t('settings.author_performance.header')}</div>
                    </div>
                )}
                <div className={`${!this.props.fromOnboard ? 'card-body' : ''}`}>
                    <div className="card-subheader">
                        {' '}
                        {t('settings.author_performance.subheader')}
                    </div>
                    <div className="settings-authors">
                        <input
                            name="report_permission_all_authors"
                            type="checkbox"
                            id="all_authors"
                            onChange={this.onChangeInput}
                            checked={this.state.report_permission_all_authors}
                        />
                        <label htmlFor="all_authors">
                            <strong>{t('settings.author_performance.disable_all_authors')}</strong>
                        </label>
                    </div>
                    <div className="settings-authors">
                        <input
                            type="checkbox"
                            name="report_permission_individual_authors"
                            id="individual_authors"
                            onChange={this.onChangeInput}
                            checked={this.state.report_permission_individual_authors}
                        />
                        <label htmlFor="individual_authors">
                            <strong>
                                {t('settings.author_performance.disable_individual_author')}
                            </strong>
                        </label>
                    </div>
                    <div className="card-subheader mt-20 mb-5">Competitive Analysis Opt In</div>
                    <div className="card-subheader small">
                        Our Competitive Analysis report is designed to give you a deep understanding
                        of how your content stacks up against the competition in Google Discover.
                    </div>
                    <div className="settings-authors">
                        <input
                            name="show_competitive_analysis"
                            type="checkbox"
                            id="opt_in"
                            onChange={this.onChangeInputOptIn}
                            checked={this.state.show_competitive_analysis}
                        />
                        <label htmlFor="opt_in">
                            <strong>Opt In</strong>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(AuthorSettings);
